<template>
  <div>
    <iframe
      v-if="shouldRenderIframe"
      ref="iframe"
      :src="webUrl"
    />
    <div
      v-if="!shouldRenderIframe"
      class="gray-bg"
    >
      <div class="landingPage">
        <div class="white-card d-flex content-between items-center row automated-payroll">
          <div class="content-holder">
            <h6>STARTING JANUARY 2024</h6>
            <h2>Transform Your Payroll Experience</h2>
            <p>
              Simplify your payroll process with just a few clicks. Discover a
              stress-free, automated solution with Atto&apos;s cutting-edge
              payroll product.
            </p>
            <Button
              class="atto-btn black-btn"
              @click="getEarlyAccess"
            >
              Get Early Access
            </Button>
          </div>
          <div class="img-wrapper">
            <img
              src="~@assets/images/ready-made-professional-timesheets@3x.png"
              alt="Automated Payroll Banner"
              width="648"
              height="600"
            >
          </div>
        </div>
        <div class="white-card d-flex payroll-magic">
          <div class="d-flex content-center items-center">
            <h2>One-Click Payroll Magic</h2>
            <p>
              Turn payroll into a breeze. Atto&apos;s fully automated solution
              streamlines every step, from payroll processing to tax filings.
              Discover a new level of efficiency with Atto.
            </p>
          </div>
          <div class="d-flex row content-between items-start magic-content">
            <div class="d-flex column">
              <img
                src="~@assets/images/automated-tax-calculations@3x.png"
                alt="Work in the office"
                width="378"
                height="380"
              >
              <div class="d-flex description">
                <h4>Automated Tax Calculations</h4>
                <p>
                  No more tax-related headaches. Attoâ€™s automated solution
                  effortlessly calculates local, state, and federal taxes across
                  all 50 states.
                </p>
              </div>
            </div>
            <div class="d-flex column">
              <img
                src="~@assets/images/perfect-paydays-every-time@3x.png"
                alt="Work on the go"
                width="378"
                height="380"
              >
              <div class="d-flex description">
                <h4>
                  Perfect Paydays,
                  <br> Every Time
                </h4>
                <p>
                  Say hello to smoother paydays. With flexible payment
                  timelines, our system ensures your team is paid correctly and
                  on time.
                </p>
              </div>
            </div>
            <div class="d-flex column">
              <img
                src="~@assets/images/seamless-tax-filings@3x.png"
                alt="Work at job sites"
                width="378"
                height="380"
              >
              <div class="d-flex description">
                <h4>
                  Seamless <br> Tax Filings
                </h4>
                <p>
                  Navigate tax filing with ease. Seamlessly generate, submit,
                  and report tax filings, connecting to over 100 government
                  agencies with ease.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="white-card d-flex simple-setup">
          <div class="d-flex content-between items-center title-holder">
            <h2>Simple Setup, Happy Employees</h2>
            <p>
              Get started in a snap. Atto&apos;s user-friendly interface makes
              it easy for both you and your employees to set up and manage
              payroll without the fuss.
            </p>
          </div>
          <div class="d-flex row-content content-between items-center setup-steps">
            <div class="d-flex centered-content">
              <div class="icon-holder">
                <img
                  src="~@assets/images/download-atto.svg"
                  alt="Download Atto"
                  width="77.26"
                  height="77.6"
                >
              </div>
              <h4>1. Setup Your Company</h4>
              <p>Quickly configure your company&apos;s payroll settings.</p>
            </div>
            <div class="d-flex centered-content">
              <div class="icon-holder invite-member">
                <img
                  src="~@assets/images/invite-new-members.svg"
                  alt="Invite new members"
                  width="77.26"
                  height="77.6"
                >
              </div>
              <h4>2. Onboard Your Team</h4>
              <p>Seamless employee onboarding and documentation process.</p>
            </div>
            <div class="d-flex centered-content">
              <div class="icon-holder">
                <img
                  src="~@assets/images/ready-to-go.svg"
                  alt="Download Atto"
                  width="80.03"
                  height="88.96"
                >
              </div>
              <h4>3. Run Payroll</h4>
              <p>Review and approve your payroll in just a few clicks.</p>
            </div>
          </div>
        </div>
        <div class="green-bg d-flex row content-between items-start">
          <div class="d-flex content-start col content-holder">
            <h1>Choose Atto. Embrace simplicity.</h1>
            <p>
              Experience the difference a fully automated payroll solution can make for your business. Get early access to
              Atto Payroll today and let us work our magic.
            </p>
          </div>
          <Button
            class="atto-btn black-btn"
            @click="getEarlyAccess"
          >
            Get Early Access
          </Button>
          <payroll-sign-up-component v-if="showGetEarlyAccess" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PayrollSignUpComponent from "./components/PayrollSignUpComponent";
export default {
  name: "PayrollComponent",
  components: {
    PayrollSignUpComponent,
  },
  data() {
    return {
      shouldRenderIframe: true, //TODO: This will be back to false after we do responsive part on 'landing page'
      showGetEarlyAccess: false,
      webUrl: null
    }
  },
  computed: {
    isPayrollEnabled() {
      return this.$store.state.payroll_checkhq_web_enabled
    },
    payrollCheckHQUrl() {
        return this.$store.state.checkhq_payroll_url;
    },
    user() {
      return this.$store.state.user || null;
    },
    token() {
      return localStorage.getItem("access_token")
    }
  },
  created() {
    if (this.isPayrollEnabled) {
      this.shouldRenderIframe = true;
      const hostname = window.location.hostname;
      this.webUrl = `${this.payrollCheckHQUrl}/login?accessToken=${this.token}&user=${encodeURIComponent(JSON.stringify(this.user))}&hostname=${hostname}&nocache=${Math.random()}`
    }
  },
  mounted() {
    this.$root.$on("hideGetEarlyAccessModal", this.hideGetEarlyAccessModal);
    window.addEventListener('message', this.handleIframeMessage);
  },
  beforeDestroy() {
    this.webUrl = null;
    this.shouldRenderIframe = true;
    this.$root.$off('hideGetEarlyAccessModal');
    window.removeEventListener('message', this.handleIframeMessage);
  },
  methods: {
    getEarlyAccess() {
      this.showGetEarlyAccess = true;
    },
    hideGetEarlyAccessModal() {
      this.showGetEarlyAccess = false;
    },
    handleIframeMessage(event) {
      const header = document.querySelector('header');
      const trailNotExpired = document.querySelector('main.trial-not-expired');

      if(event.data && event.data.isPayrollMounted) {
        header.classList.remove('header-display-none');
        trailNotExpired.classList.remove('trail-not-expired-no-margin')
      }

      // Check for the right message
      if (event.data.request === 'getDimensions') {
        const iframe = this.$refs.iframe; // Using ref to get the iframe element
        const rect = iframe.getBoundingClientRect();

        // Send the dimensions and position back to the iframe
        event.source.postMessage({
          mainViewWidth: window.innerWidth,
          mainViewHeight: window.innerHeight,
          iframeX: rect.left,
          iframeY: rect.top
        }, '*');
      }
      // Handle modal status message
      if (event.data && event.data.modalStatus) {
        const body = document.body;
        if (event.data.modalStatus === 'open') {
          body.classList.add('modal-open');
        } else if (event.data.modalStatus === 'close') {
          body.classList.remove('modal-open');
        }
      }

      if(event.data && event?.data?.payrollPathName) {
        header.classList.add('header-display-none');
        trailNotExpired.classList.add('trail-not-expired-no-margin');
      } 
    },
  }
}
</script>
<style lang="scss">
  body.modal-open main.trial-not-expired{
    margin-top: 0;
    height: 100vh;
  }
  .header-display-none {
    display: none !important;
  }
  .trail-not-expired-no-margin {
    margin-top: 0 !important;
  }
 iframe {
    width: 100%;
    height: 100vh; 
    border: none;
  }
.landingPage{
  display: flex;
  padding: 0 70px !important;
  width: 100%;
  max-width: 100% !important;
  overflow: hidden;
  margin: auto;
  box-sizing: border-box;
  flex-flow: column;

  h1{
    font-family: "Calibre-Semibold";
    font-size: 100px;
    line-height: 100px;
    color: #000000;
    letter-spacing: -2px;

    @media (max-width: 1200px) {
      font-size: 80px;
      line-height: 80px;
    }
  }
  h2{
    font-family: "Calibre-Semibold";
    font-size: 60px;
    line-height: 60px;
    color: #000000;
    letter-spacing: -1px;
    @media (max-width: 1200px) {
      font-size: 40px;
      line-height: 40px;
    }
  }
  h4{
    font-family: "Calibre-Semibold";
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -0.5px;
    color: #000000;
    @media (max-width: 1200px) {
      font-size: 22px;
      line-height: 30px;
    }
  }
  h6{
    font-size: 20px;
    line-height: 20px;
    font-family: "Calibre-Medium";
    letter-spacing: -0.5px;
  }
  p{
    font-family: "Calibre-Regular";
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -0.5px;
    @media (max-width: 1200px) {
      font-size: 22px;
      line-height: 30px;
    }
  }
  .d-flex{
    display: flex;
  }
  .content-center{
    justify-content: center;
  }
  .content-start{
    justify-content: flex-start;
  }
  .content-end{
    justify-content: flex-end;
  }
  .content-between{
    justify-content: space-between;
  }
  .content-around{
    justify-content: space-around;
  }
  .items-end{
    align-items: flex-end;
  }
  .items-start{
    align-items: flex-start;
  }
  .items-center{
    align-items: center;
  }
  .column{
    flex-flow: column;
  }
  .row-content{
    flex-flow: row;
  }
  .white-card{
    box-sizing: border-box;
    height: auto;
    max-width: 100%;
    margin: 70px auto 0;
    width: 100%;
    border: 2px solid #E3E3E3;
    border-radius: 20px;
    background-color: #ffffff;
  }

  .content-holder{
    max-width: 450px;
    width: 100%;
    display: flex;
    flex-flow: column;
  }
  .automated-payroll{
    padding: 109px 0 110px 80px;
    gap: 69px;
    justify-content: space-between;
    align-items: center;
    flex-flow: row;
    box-shadow: none;
    .black-btn{
      max-width: 270px;
      margin-top: 40px;
    }
    h6{
      color: $atto-darker-green;
      text-transform: uppercase;
    }
    h2{
      margin: 0.75rem 0 1rem;
    }
    .img-wrapper{
      display: flex;
      max-width: 648px;
      width: 100%;
      box-shadow: 0 0 35px 0 rgba(0,0,0,0.1);
      img{
        width: 100%;
        height: auto;
      }
    }
  }
  .black-btn {
    max-width: 300px !important;
    min-width: 300px !important;
    width: 100% !important;
    background-color: #000000 !important;
    color: #ffffff;
    padding: 17px 0 !important;
    text-align: center;
    font-family: "Calibre-Semibold" !important;
    font-size: 25px !important;
    line-height: 30px !important;
    border-radius: 4px;
    &:hover{
      background-color: #262626 !important;
    }
  }
  p{
    font-size: 32px;
    letter-spacing: -0.5px;
    line-height: 40px;
    font-family: "Calibre-Regular";
  }
  .payroll-magic{
    padding: 120px 80px;
    box-shadow: none;
    .content-center{
      flex-flow: column;
    }

    p{
      margin: 16px 0 80px;
      max-width: 800px;
      text-align: center;
      color: $atto-font-color;
    }
    .magic-content{
      gap: 3px;
      flex-flow: row;
      max-width: 1140px;
      justify-content: center;
      margin: auto;
      img{
        width: 100%;
        height: auto;
        max-width: 378px;
        box-sizing: content-box;
      }
      .description{
        margin-top: 40px;
        justify-content: center;
        align-items: flex-start;
        text-align: left;
        max-width: 280px;
        flex-flow: column;
        .icon-wrapper{
          width: 120px;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;

        }
        h4{
          margin: 10px 0 16px;
          width: 100%;
          line-height: 36px;
          @media (max-width: 1200px) {
            margin-bottom: 20px;
          }
        }
        p{
          font-size: 22px;
          line-height: 30px;
          text-align: left;
          margin: 0;
          @media (max-width: 1200px) {
            font-size: 18px;
            line-height: 26px;
          }
        }
      }
    }
  }
  .simple-setup{
    padding: 120px 80px;
    text-align: center;
    box-shadow: none;
    .title-holder{
      flex-flow: column;
    }
    p{
      max-width: 780px;
      margin: 12px 0 42px;
    }
    .setup-steps{
      max-width: 1140px;
      margin: auto;
      align-items: flex-start;
    }
    .centered-content{
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      max-width: 360px;
      width: 100%;
      box-sizing: border-box;
      flex-flow: column;

      .icon-holder{
        width: 180px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.invite-member{
          &:before{
            content: "";
            width: 149px;
            height: 10px;
            background: url("~@assets/images/step-arrow-forward.svg") no-repeat center;
            position: absolute;
            margin-left: -340px;

            @media (max-width: 1200px) {
              width: 100px;
              margin-left: -254px;
              background-size: contain;
            }
          }
          &:after{
            content: "";
            width: 149px;
            height: 10px;
            background: url("~@assets/images/step-arrow-forward.svg") no-repeat center;
            position: absolute;
            margin-right: -340px;

            @media (max-width: 1200px) {
              width: 100px;
              margin-left: -105px;
              background-size: contain;
            }
          }
        }
      }
      h4{
        margin: 33px 0 8px;
      /*  @media (max-width: 1293px) {
          font-size: 22px;
        }*/
      }
      p{
        font-size: 22px;
        line-height: 30px;
        margin: 0;
        letter-spacing: 0;
        padding: 0 20px 17px;
     /*   @media (max-width: 1293px){
          padding-left: 5px;
          padding-right: 5px;
          max-width: 220px;
          font-size: 18px;
          line-height: 26px;
        }*/
      }
    }
  }
  .green-bg{
    height: auto;
    max-width: 100%;
    margin: 70px auto 70px;
    width: 100%;
    border-radius: 8px;
    padding: 120px 80px;
    background-color: #99E3EA;
    box-sizing: border-box;

    .content-holder{
      max-width: 766px;
      padding: 0;
      h1{
        margin: 0;
      }
      p{
        padding-right: 46px;
        margin: 20px 0 0 0;
      }
    }
    button{
      margin-top: 13px;
    }
  }
}
</style>